'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  active: function active(_ref) {
    var theme = _ref.theme;
    return {
      styles: '\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    '
    };
  },

  disabled: function disabled() {
    return {
      styles: '\n      opacity: 0.5;\n      pointer-events: none;\n    '
    };
  },

  small: function small() {
    return '\n    font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  ';
  }
}; /**
    * Component: ButtonLink
    *
    */

var styles = function styles(_ref2) {
  var theme = _ref2.theme;
  return '\n  background: transparent;\n  border: none;\n  color: ' + theme.colors.base.link + ';\n  cursor: pointer;\n  font-size: ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  line-height: ' + (0, _decisivUiUtils.px2rem)(16) + ';\n  outline: none;\n  padding: 0;\n  text-decoration: none;\n  text-transform: capitalize;\n  white-space: nowrap;\n  &:hover {\n    color: ' + theme.colors.base.linkHover + ';\n    text-decoration: underline;\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      link: _propTypes2.default.string.isRequired,
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('ButtonLink', _styledComponents2.default.button, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/ButtonLink/index.js
// module id = 1515
// module chunks = 2